export default __webpack_public_path__ + "assets/images/gyra-black3edbd0146f8c7ba378e7b8050d3ceb1f.png";